import { render, staticRenderFns } from "./AboutMethodTitleBlock.vue?vue&type=template&id=2dd589b0"
import script from "./AboutMethodTitleBlock.vue?vue&type=script&lang=js"
export * from "./AboutMethodTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutMethodTitleBlock.vue?vue&type=style&index=0&id=2dd589b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports